import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-card',
  templateUrl: './common-card.component.html',
  styleUrls: ['./common-card.component.scss']
})
export class CommonCardComponent implements OnInit {
  @Input() showSalyLogo: boolean = true;

  constructor() { }

  ngOnInit(): void {
  }
  items = [
    { src: 'assets/img/4974998.png', text: 'Payment Gateway for Website & App' },
    { src: 'assets/img/5272922.png', text: 'Dynamic & Static QR code' },
    { src: 'assets/img/6168795.png', text: 'Payment Profiles to Collect payments' },
    { src: 'assets/img/7170467.png', text: 'Free Online Store with Payment Integration' },
    { src: 'assets/img/5727735.png', text: 'Free Booking Solution' }
  ];
}
